/**
 * Фильтры экрана «Список» (§2.3 спецификации): «Забрать», «Все», «Мои
 * задания» — ровно три чипа, не пять переключателей, как было раньше.
 *
 * «Забрать» не пересчитывает причины сам — берёт готовый `needsPickup` из
 * `describeBike()`. Второе определение «что считается проблемой» здесь
 * значило бы то же расхождение, ради предотвращения которого написан
 * `describe-bike.ts`.
 */

import { distanceM, hasPosition, type LatLng } from './geo'

export const LIST_FILTERS = ['pickup', 'all', 'mine'] as const
export type ListFilter = (typeof LIST_FILTERS)[number]

export const listFilterLabel: Record<ListFilter, string> = {
  pickup: 'Забрать',
  all: 'Все',
  mine: 'Мои задания',
}

export type ListItem = {
  /** Из `describeBike(bike).needsPickup`. */
  needsPickup: boolean
  /** Есть задача на этот байк, взятая ТЕКУЩИМ скаутом. */
  myClaimedTask: boolean
}

/**
 * Порядок строк: «За зоной» сверху (Ержан, 01.10: водитель собирает их
 * первыми), внутри каждой группы — ближе выше. Без своей позиции внутри
 * групп остаётся порядок сервера; без координат строка уходит в конец
 * своей группы. Что считать «за зоной», решает экран (`outside`).
 */
export function listOrder<T extends { lat: number; lng: number }>(
  rows: readonly T[],
  me: LatLng | null,
  outside: (row: T) => boolean,
): T[] {
  const group = (r: T) => (outside(r) ? 0 : 1)
  const dist = (r: T) => (me && hasPosition(r) ? distanceM(me, r) : Number.POSITIVE_INFINITY)
  return [...rows].sort((a, b) => group(a) - group(b) || (me ? dist(a) - dist(b) : 0))
}

export function matchesListFilter(item: ListItem, filter: ListFilter): boolean {
  switch (filter) {
    case 'all':
      return true
    case 'pickup':
      return item.needsPickup
    case 'mine':
      return item.myClaimedTask
  }
}
